<template>
  <employee-profile>
    <modal-dialog-prevent-leave
      v-bind:is-shown="isShownDialogLeaveConfirm"
      v-on:back="isShownDialogLeaveConfirm = false"
      v-on:leave="leaveWithoutSave"
      v-on:save="saveAndLeave" />
    <form
      class="employee-admission"
      v-on:submit.prevent="onSubmitEmployeeEdit"
    >
      <input-checkbox
        v-bind:disabled="isDismissed"
        v-if="!isAdmin"
        title="Выводить в расписании"
        v-model="employeeAdmission.isEnabledWorkingScheduling"
        v-on:input="checkChanged"
      />
      <input-checkbox
        v-bind:disabled="isDismissed"
        v-if="!isAdmin && employeeAdmission.isEnabledWorkingScheduling"
        title="Запретить ставить сотрудника в другие кабинеты в расписании"
        v-model="employeeAdmission.isForbidSelectOtherCabinetsInSchedule"
        v-on:input="checkChanged"
      />
      <div
        class="employee-admission__contact"
        v-if="!isAdmin && employeeAdmission.isEnabledWorkingScheduling"
      >
        <div class="employee-admission__contact__row">
          <multiline-select
            v-bind:disabled="isDismissed"
            v-bind:items="cabinetOptionList"
            v-bind:label="'Выберите кресло'"
            v-bind:hint="'Кресло по умолчанию нужно для удобства заполнения расписания. В графике работы вы можете в любой день указывать сотруднику другие кресла'"
            v-model="employeeAdmission.cabinetIds"
            v-on:input="checkChanged"
            class="employee-admission__multiline explanation" />
        </div>
        <p
          class="employee-admission__error-text"
          role="alert"
          v-bind:key="id"
          v-for="(text, id) in cabinetInputErrors"
        >{{ text }}</p>
      </div>
      <div
        v-if="!isAdmin && employeeAdmission.isEnabledWorkingScheduling"
      >
        <label class="employee-admission__step">
          <span class="employee-admission__step__label">Шаг приёма</span>
          <select
            v-bind:disabled="isDismissed"
            class="employee-admission__step__input"
            id="duration-appointment"
            v-model="employeeAdmission.timeStepMinutes"
            v-on:input="checkChanged"
          >
            <option
              v-for="(option, index) in timeStepOptionList"
              v-bind:key="index"
              v-bind:value="option.value"
            >{{ option.title }}</option>
          </select>
        </label>
      </div>
      <div v-if="employeeAdmission.isEnabledWorkingScheduling">
        <label
          class="employee-admission__group"
          v-bind:class="{ field_error: infoInputErrors.length > 0 }"
        >
          <span class="employee-admission__label">Информация о сотруднике</span>
          <textarea
            v-bind:disabled="isDismissed"
            class="employee-admission__textarea"
            placeholder="Например, записывать только пациентов старше 18 лет"
            v-model="employeeAdmission.info"
            v-on:input="checkChanged"
            maxlength="100"
            rows="2"
            v-letter-capital
          />
          <p
            class="field__error-text"
            role="alert"
            v-bind:key="id"
            v-for="(text, id) in infoInputErrors"
          >{{ text }}</p>
        </label>
      </div>
      <template v-if="false">
        <div class="employee-admission__contact__row">
          <b>Уведомлять о начале приема</b>
          <button
            class="employee-admission__button-remove"
            type="button"
            v-if="employeeAdmission.notifyChannel"
            v-on:click="employeeAdmission.notifyChannel = ''; checkChanged()"
          >Сбросить</button>
        </div>
        <div
          v-for="({
            title,
            value,
            dispatch_routing,
          }, index) in notificationChannels"
          v-bind:key="`radio-key-${index}`"
          class="employee-admission__contact__row"
        >
          <label class="employee-admission__radio">
            <input
              type="radio"
              v-bind:id="`radio-${value}`"
              name="radio-channel-notification"
              v-bind:value="value"
              v-on:input="onInputEmployeeNotifyChannel($event); checkChanged()"
              v-model="employeeAdmission.notifyChannel">
            <span>{{ title }}</span>
          </label>
          <input-select
            v-if="dispatch_routing.length"
            title="Мессенджер"
            option-value-key="value"
            option-title-key="title"
            v-bind:options="dispatch_routing"
            v-model="employeeAdmission.dispatchRouting"
            v-bind:violations="dispatchRoutingInputErrors"
          />
        </div>
        <p
          class="violation"
          role="alert"
          v-for="violationText in notifyChannelInputErrors"
          v-bind:key="violationText"
        >{{ violationText }}</p>
      </template>
      <the-tooltip v-if="isDismissed" position="top">
        <template v-slot:trigger="{ listenerObject }">
          <button
            disabled
            class="employee-admission__button-save"
            type="button"
            v-on="listenerObject"
          >
            Сохранить
          </button>
        </template>
        Сохранение невозможно. Сотрудник уволен
      </the-tooltip>
      <button
        v-else
        class="employee-admission__button-save"
        type="submit"
        v-bind:disabled="isAwaitRequest || !hasChanges"
      >
        Сохранить
      </button>
    </form>
    <modal-dialog
      title="Чтобы подключить модуль, свяжитесь с вашим менеджером"
      v-model="showSupportContactsDialog"
      with-cross
    >
      <a class="employee-admission__contacts" v-bind:href="$options.supportPhoneHref">
        {{ $options.supportManagerName }} {{ $options.supportPhoneTitle }}
      </a>
    </modal-dialog>
  </employee-profile>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox.vue';
import MultilineSelect from '@/components/MultilineSelect.vue';
import EmployeeProfile from '@/views/ClinicPanel/EmployeeProfile.vue';
import { EmployeeAdmissionEditRequest } from '@/storage/gateways/EmployeeGateway';
import notifierMixin from '@/mixins/notifierMixin';
import ModalDialogPreventLeave from '@/components/ModalDialogPreventLeave.vue';
import preventLeaveWithoutConfirmMixin from '@/mixins/preventLeaveWithoutConfirmMixin';
import debounce from 'lodash.debounce';
import ModalDialog from '@/components/ModalDialog.vue';
import aboutMixin from '@/mixins/aboutMixin';
import TheTooltip from '@/components/TheTooltip.vue';
import onBoardingMixin from '@/mixins/onBoardingMixin';
import InputSelect from '@/components/InputSelect.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.profileInputErrors ? vm.profileInputErrors[cause] : []
);

/**
 * @description Данные приема сотрудника
 * @param {array}   cabinetIds
 * @param {string}  info
 * @param {number}  timeStepMinutes
 * @param {boolean} isEnabledWorkingScheduling
 * @param {boolean} isForbidSelectOtherCabinetsInSchedule
 * @param {string}  notifyChannel
 * @param {string}  dispatchRouting
 * @constructor
 */
function EmployeeAdmission(
  cabinetIds = [],
  info = '',
  timeStepMinutes = 30,
  isEnabledWorkingScheduling = true,
  isForbidSelectOtherCabinetsInSchedule = false,
  notifyChannel = '',
  dispatchRouting = '',
) {
  this.cabinetIds = cabinetIds;
  this.info = info;
  this.timeStepMinutes = timeStepMinutes;
  this.isEnabledWorkingScheduling = isEnabledWorkingScheduling;
  this.isForbidSelectOtherCabinetsInSchedule = isForbidSelectOtherCabinetsInSchedule;
  this.notifyChannel = notifyChannel;
  this.dispatchRouting = dispatchRouting;

  this.toString = () => JSON.stringify({
    cabinetIds: this.cabinetIds,
    info: this.info,
    timeStepMinutes: this.timeStepMinutes,
    isEnabledWorkingScheduling: this.isEnabledWorkingScheduling,
    isForbidSelectOtherCabinetsInSchedule: this.isForbidSelectOtherCabinetsInSchedule,
    notifyChannel: this.notifyChannel,
    dispatchRouting: this.notifyChannel === 'messengers' ? this.dispatchRouting : null,
  });

  this.initial = this.toString();
  this.isChanged = () => this.toString() !== this.initial;

  /**
   * @description Обновить.
   * @returns {void}
   */
  this.refresh = () => {
    this.initial = this.toString();
  };
}

/**
 * @description Компонент пункта профиля сотрудника "Основное".
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Имеет изменения
     * @returns {boolean}
     */
    hasChanges() {
      return this.employeeAdmission.isChanged();
    },
    needPreventLeave() {
      return this.isChanged;
    },
    employeeId: (vm) => parseInt(vm.$route.params.id, 10),
    /**
     * @description Является ли сотрудник администратором.
     * @return {boolean}
     */
    isAdmin() {
      return this.roleId === 'admin';
    },
    cabinetInputErrors: resolveInputErrors('cabinet-id'),
    infoInputErrors: resolveInputErrors('info'),
    dispatchRoutingInputErrors: resolveInputErrors('dispatch_routing'),
    notifyChannelInputErrors: resolveInputErrors('notify_channel'),
  },
  tooltipText: 'Кабинет по умолчанию нужен для удобства заполнения расписания. В графике работы вы можете в любой день указывать сотруднику другие кабинеты.',
  components: {
    InputSelect,
    TheTooltip,
    ModalDialogPreventLeave,
    EmployeeProfile,
    MultilineSelect,
    InputCheckbox,
    ModalDialog,
  },
  created() {
    this.fetchEmployeeAdmission();
    this.fetchProfileOptions();
  },
  data() {
    return {
      employeeAdmission: new EmployeeAdmission(),
      cabinetOptionList: [],
      timeStepOptionList: [],
      isAwaitRequest: false,
      profileInputErrors: {},
      isDismissed: false,
      isChanged: false,
      availableNotificationChannels: [],
      showSupportContactsDialog: false,
      notificationChannels: [],
    };
  },
  methods: {
    /**
     * @description Получить данные по приему сотрудника
     * @returns {void}
     */
    fetchEmployeeAdmission() {
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = async (employee) => {
        this.profileInputErrors = {};
        this.employeeAdmission = new EmployeeAdmission(
          employee.cabinetIds,
          employee.info,
          employee.timeStepMinutes,
          employee.isEnabledWorkingScheduling,
          employee.isForbidSelectOtherCabinetsInSchedule,
          employee.notifyChannel,
          employee.dispatchRouting,
        );
        this.isDismissed = employee.isDismissed;
        this.availableNotificationChannels = employee.availableNotificationChannels;
      };
      const response = this.$employeeGateway.viewAdmission(this.employeeId);
      response.then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Получить опции по профилю.
     * @returns {void}
     */
    fetchProfileOptions() {
      const onResponse = (result) => {
        this.cabinetOptionList = result
          .cabinetList
          .map(({ name: title, id: value }) => ({ title, value }));
        this.timeStepOptionList = result
          .timeStepList
          .map(({ title, number_minutes: value }) => ({ title, value }));
        this.notificationChannels = result.notificationChannels;
      };
      this.$suggestionGateway.getEmployeeCreation().then(onResponse);
    },
    /**
     * @description Отправить событие отправки редактирования сотрудника.
     * @returns {Promise}
     */
    onSubmitEmployeeEdit() {
      const request = this.makeEmployeeAdmissionRequest();
      this.isAwaitRequest = true;
      const onFail = (error) => {
        this.profileInputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
        this.isAwaitRequest = false;
      };
      const onSuccess = (result) => {
        const { title, body } = result.onboarding_status;
        this.checkAndUpdate(title, body);
        this.notifySuccess(result.title);
        this.profileInputErrors = {};
        this.isAwaitRequest = false;
        this.isChanged = false;
        this.employeeAdmission.refresh();
      };
      const response = this.$employeeGateway.editAdmission(request);
      response.then((result) => result.fold(onFail, onSuccess));
      return response;
    },
    /**
     * @description Создать запрос на редактирование.
     * @returns {EmployeeAdmissionEditRequest}
     */
    makeEmployeeAdmissionRequest() {
      return new EmployeeAdmissionEditRequest(
        this.employeeId,
        this.employeeAdmission.cabinetIds,
        this.employeeAdmission.info,
        this.employeeAdmission.isEnabledWorkingScheduling,
        this.employeeAdmission.isForbidSelectOtherCabinetsInSchedule,
        this.employeeAdmission.timeStepMinutes,
        this.employeeAdmission.notifyChannel,
        this.employeeAdmission.dispatchRouting,
      );
    },
    async saveAndLeave() {
      const result = await this.onSubmitEmployeeEdit();
      result.forEach((message) => {
        this.notifySuccess(message.title);
        this.actionAfterClosingDialogLeaveConfirm();
      });
      this.isShownDialogLeaveConfirm = false;
    },
    /**
     * @description Проверить наличие изменений.
     * @returns {void}
     */
    checkChanged: debounce(function _() {
      this.isChanged = this.employeeAdmission.isChanged();
    }, 300),
    onInputEmployeeNotifyChannel(event) {
      if (this.availableNotificationChannels.includes(event.target.value)) {
        return;
      }
      this.showSupportContactsDialog = true;
    },
  },
  mixins: [
    aboutMixin,
    notifierMixin,
    preventLeaveWithoutConfirmMixin,
    onBoardingMixin,
  ],
  name: 'ClinicPanelEmployeeProfileAdmission',
};
</script>

<style lang="scss">
@use "@/scss/buttons";
.employee-admission {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 37px 0 0 0;
  height: 100%;
  width: 100%;
  max-width: 700px;
  &__contact {
    display: flex;
    flex-direction: column;
    padding: 17px 0 0 0;
    &__row {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
    }
  }
  &__contacts {
    font-size: 1rem;
    margin-top: -1rem;
  }
  &__multiline {
    flex: 1;
    &.explanation {
      .multiline-select__row:first-child {
        .multiline-select__placeholder {
          cursor: pointer !important;
          pointer-events: auto;
          &:after {
            content: "?";
            font-size: 13px;
            margin: 0 0 0 5px;
          }
        }
      }
    }
  }
  &__error-text {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 12px;
    padding: 0;
    margin: 5px 0 0 0;
    background-color: transparent!important;
  }
  &__step {
    display: grid;
    align-items: center;
    gap: 2px;
    width: fit-content;
    &__label {
      font-size: 12px;
      line-height: 16px;
      color: #90A0B7;
    }
    &__input {
      background-color: #ffffff;
      background-image: url("@/assets/img/checked/checked-grey.svg");
      background-position: right 17px center;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      outline: none;
      height: 40px;
      min-width: 200px;
      padding: 0 10px;
      appearance: none;
      font-size: 16px;
      color: #192a3e;
      font-weight: 400;
      &.validate {
        border-color: var(--warning-color);
      }
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 2px solid #0489e0;
        outline: 0;
        background-image: url("@/assets/img/checked/checked-grey-top.svg");
      }
      &:disabled {
        background-color: #fff;
        background-image: url("@/assets/img/checked/checked-grey.svg");
      }
    }
  }
  &__group {
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    &.field_error {
      .employee-creation__label {
        color: var(--warning-color);
      }
    }
  }
  &__label {
    color: #90A0B7;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }
  &__textarea {
    background: #ffffff;
    border: 1px solid #c2cfe0;
    border-radius: 4px;
    z-index: 2;
    outline: none;
    -webkit-appearance: none;
    width: 100%;
    padding: 10px;
    appearance: none;
    font-size: 16px;
    font-weight: 400;
    color: var(--reading-color);
    margin: 0 0 2px 0;
    &:focus {
      background-color: #fff;
      border: 2px solid #0489e0;
      margin: 0;
    }
    &::placeholder {
      color: var(--placeholder-color);
    }
  }
  &__button-save {
    @include buttons.btn-blue(100%, 48px, 16px);
    min-height: 48px;
    max-width: 174px;
    padding: 0;
    margin: 10px 0 0 0;
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__button-remove {
    text-align: left;
    color: #0489e0;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
  }
  &__radio > input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  &__radio > span {
    display: inline-flex;
    align-items: center;
    user-select: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    cursor: pointer;
  }
  &__radio > span::before {
    content: "";
    display: inline-block;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    flex-grow: 0;
    border: 1px solid #90a0b7;
    border-radius: 50%;
    margin-right: 10px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50% 50%;
  }
  &__radio > input:not(:disabled):not(:checked) + span:hover::before {
    border: 1px solid #0489e0;
  }
  &__radio > input:checked + span::before {
    border: 1px solid #0489e0;
    background-color: #0489e0;
    box-shadow: inset 0 0 0 6px #fff;
  }
}
@media screen and (max-width: 480px) {
  .employee-admission {
    &__step {
      width: 100%;
      &__input {
        width: 100%;
      }
    }
  }
}
</style>
